import React from "react";

function DollarStepper(props){
  return(
    <div style={{display:"flex",alignItems:"center"}} >
      <div style={{backgroundColor:"white",display:"flex",alignItems:"center",border:"1px solid #0000001a"}}>
        <div style={buttonStyle}
            onClick={()=>{props.onChange(props.value-10)}}>
          -
        </div>
        <div style={{display:"flex",fontSize:32,padding:"0px 30px"}}>
          ${props.value}
        </div>
        <div style={buttonStyle}
            onClick={()=>props.onChange(props.value+10)}>
          +
        </div>
      </div>
    </div>
  )
}

const buttonStyle={
  userSelect:"none",
  fontSize:30,
  cursor:"pointer",
  display:"flex",
  width:60,
  height:60,
  justifyContent:"center",
  alignItems:"center",
  background:"#0000001a",
}

export default DollarStepper;
